/**
 * WEB-3738: флаг черновика кабинета (решение владельца 23.10.2026). Верстается
 * весь макет при «Черновик: вкл», а то, чего ещё нет на сервере (функции-
 * предложения и целые блоки), прячется этим флагом: на бою его нет в разметке
 * вовсе. Включён на стенде и локально (`VITE_CABINET_DRAFT=true` при сборке),
 * на бою переменной нет — выключен.
 *
 * Читать флаг только через `useDraftEnabled` / `IfDraft` / `DraftOnly`
 * (`components/kit`), не импортом этого модуля на экранах.
 *
 * IMPORTANT: use the literal `import.meta.env.VITE_*` access pattern — Vite's
 * static replacement only matches the literal form (mirror of topup-enabled.ts).
 */
export const CABINET_DRAFT_ENABLED: boolean =
  import.meta.env.VITE_CABINET_DRAFT === 'true';
